/**
 * Interest Rates API Service
 * Handles crypto interest rates endpoints
 */

import axiosInstance from '@/lib/axios'
import API_ROUTES from '@/lib/api-routes'
import type {
    CryptoInterestRate,
    CryptoInterestRatesResponse,
    UpdateCryptoInterestRateRequest,
    BulkUpdateCryptoInterestRatesRequest,
} from '@/types/interest-rate'

/**
 * Get all crypto interest rates
 * GET /admin/currency/interest-rates
 */
export const getInterestRates = async (): Promise<CryptoInterestRate[]> => {
    const response = await axiosInstance.get<CryptoInterestRatesResponse>(
        API_ROUTES.INTEREST_RATES.LIST
    )
    return response.data.data
}

/**
 * Update interest rate for a specific cryptocurrency
 * PATCH /admin/currency/interest-rates/{cryptoId}
 */
export const updateInterestRate = async (
    cryptoId: string,
    data: UpdateCryptoInterestRateRequest
): Promise<CryptoInterestRate> => {
    const response = await axiosInstance.patch<{
        status: string
        statusCode: number
        message: string
        data: CryptoInterestRate
    }>(API_ROUTES.INTEREST_RATES.UPDATE(cryptoId), data)
    return response.data.data
}

/**
 * Bulk update interest rates for multiple cryptocurrencies
 * PATCH /admin/currency/interest-rates/bulk
 */
export const bulkUpdateInterestRates = async (
    data: BulkUpdateCryptoInterestRatesRequest
): Promise<CryptoInterestRate[]> => {
    const response = await axiosInstance.patch<CryptoInterestRatesResponse>(
        API_ROUTES.INTEREST_RATES.BULK_UPDATE,
        data
    )
    return response.data.data
}
